import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { PROCESS } from "@/data/urban";

export const HowItWorks = () => (
  <section id="how" className="py-20 md:py-28 bg-black text-white">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="max-w-2xl">
        <Reveal><div className="overline text-white/60">How It Works</div></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">From requirement to handover — in seven steps.</h2>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PROCESS.map((s, i) => (
          <motion.div key={s.step} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
            className="border border-white/15 rounded-2xl p-6 hover:border-white/50 transition-colors">
            <div className="font-heading text-4xl font-extrabold text-white/25">{s.step}</div>
            <h3 className="mt-3 font-heading text-base font-bold">{s.title}</h3>
            <p className="mt-1.5 text-sm text-white/60">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
